export default function getLanguage() {
    const val = localStorage.getItem('@rps/language')

    return val || 'en'
}